import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose } from 'recompose'
import { connect } from 'react-redux'

import styles from './styles.scss'
import NvqualFinalReport from 'containers/NvqualReport/FinalReport'
import CardLoading from 'components/display/CardLoading'
import { 
  nvqualDetailsLoadingSelector,
  currentRevisionSelector,
} from './selectors';

const mapStateToProps = (state) => {
  return {
    isLoading: nvqualDetailsLoadingSelector(state),
    currentRevision: currentRevisionSelector(state),
  }
}
import {
  default as Collapse
} from 'components/fulcrum/collapse/Collapse'

class NvqualDetailsSpec extends Component {


  renderContents = () => {
    const {
      isLoading,
      currentRevision
    } = this.props 

    if(isLoading){
      return (<CardLoading />)
    }

    if(!currentRevision){
      return (<div></div>)
    }

    return(
      <div styleName='nvqual_details'>
        <NvqualFinalReport currentRevision={currentRevision}/>
      </div>
    )

  }

  render() {
    const { collapse } = this.props
    return(
      <Collapse collapse={collapse}>
        {this.renderContents()}
      </Collapse>
    )
  }
}


const withConnect = connect(mapStateToProps, null)
const withStyles = CSSModules(styles);
const enhance = compose(withConnect, withStyles);
export default enhance(NvqualDetailsSpec);